module.exports = __webpack_public_path__ + "public/img/arrow-t.881830df.svg";